// Fade direction: 'left', 'right', 'bottom'
import React, { useRef, useState, useEffect } from "react";

export function FadeIn({ children, direction = "left" }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.13 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={
      direction === "left" ? `fade-in-left ${visible ? "visible" : ""}` :
      direction === "right" ? `fade-in-right ${visible ? "visible" : ""}` :
      direction === "bottom" ? `fade-in-bottom ${visible ? "visible" : ""}` : ""}
    >
      {children}
    </div>
  );
}

export function ImageFadeReveal({ src, alt, style = {} }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.08 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={`img-fade-reveal ${visible ? "visible" : ""}`}
      draggable={false}
      style={style}
    />
  );
}

export function FadeInFromBottomSection({ children, className = "" }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.05 });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={ref} 
      className={`fade-in-bottom-section ${visible ? "visible" : ""} ${className}`}
    >
      {children}
    </section>
  );
}